import _ from 'lodash';

/**
 * Invoice lock helpers shared by the station and bulk delivery edit pages.
 * A delivery with an issued/sent invoice (hasIssuedInvoice from the API) is a
 * locked record: only the internal note stays freely editable, everything else
 * needs the canEditInvoicedDeliveries permission plus a reason (server-enforced).
 */

export const isDeliveryLocked = (delivery) => Boolean(delivery && delivery.hasIssuedInvoice);

export const canEditInvoicedDeliveries = (authUser) =>
	!!_.get(authUser, ['permissions', 'canEditInvoicedDeliveries']);

//- Fallback detection of the server's "locked, reason required" rejection, for
//- when the client thought the delivery was unlocked (e.g. the invoice was
//- issued while the page was open)
export const isLockReasonRequiredError = (err) => {
	const errorText = _.isArray(err) ? err.join(' ') : String(err);
	return /reason is required/i.test(errorText);
};
